module.exports = __webpack_public_path__ + "static/media/logo.fc117930.png";